import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { env, isProdOrStaging } from '../env';

if (isProdOrStaging) {
  Sentry.init({
    dsn: 'https://9f17f2247870413197eced1bd37c3000@o438756.ingest.sentry.io/6504402',
    release: (import.meta.env.VITE_RELEASE_VERSION as string) || 'local',
    environment: env,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
